/**
 * @namespace PrivacyChoices
 * @memberof Promega.Shell
 * @description Methods for showing privacy choices modal dialog and managing cookies.
 */

import trackEvent from '../util/trackEvent';
import cookie from 'cookie_js';
import { show as showModal, hide as hideModal, lock as lockModal, unlock as unlockModal } from '../components/modal.js';

const PROMEGA_COOKIE_POLICY = "promegaCookiePolicy";
const PROMEGA_COOKIE_POLICY_MAX_AGE = 3652;   // 10 years in days

const PRIVACY_COOKIE_N = "privacyNecessaryCookiesCheckbox",
    PRIVACY_COOKIE_P = "privacyPreferenceCookiesCheckbox",
    PRIVACY_COOKIE_S = "privacyPerformanceStatsCheckbox",
    PRIVACY_COOKIE_M = "privacyMarketingCookiesCheckbox";

const PRIVACY_CHOICES_CLASS = "privacy-choices-dialog";
const PRIVACY_CHOICES_SAVE_BTN = "privacy-choices-dialog__save-button";

const COOKIE_TYPE_U = 0;
const COOKIE_TYPE_N = 1;
const COOKIE_TYPE_P = 2;
const COOKIE_TYPE_S = 4;
const COOKIE_TYPE_M = 8;

/**
 * Calculate the sum of all selected cookie checkboxes
 */
function calculateNewCookieValue() {

    let sum = COOKIE_TYPE_N;
    sum |= COOKIE_TYPE_P;
    sum |= COOKIE_TYPE_S;

    let isCookieMChecked = document.getElementById(PRIVACY_COOKIE_M).checked;
    if (isCookieMChecked) { sum |= COOKIE_TYPE_M; }

    return sum;
}

/**
 * 
 * @param {any} cookieValue
 */
function checkCookieCheckBoxes(cookieValue) {
    document.getElementById(PRIVACY_COOKIE_N).checked = true;
    document.getElementById(PRIVACY_COOKIE_P).checked = true;
    document.getElementById(PRIVACY_COOKIE_S).checked = true;
    document.getElementById(PRIVACY_COOKIE_M).checked = (PRIVACY_COOKIE_M & cookieValue);
}


/**
 * Grabs existing promegacookievalue from browser cookies
 * and sets a default of 1 (Necessary) if it didn't exist
 */
function getExistingCookieValue() {

    let existingCookieValue = cookie.get(PROMEGA_COOKIE_POLICY, 'UNKNOWN');

    if (existingCookieValue === 'UNKNOWN') {
        existingCookieValue = setPromegaCookie(COOKIE_TYPE_N);
    }

    return existingCookieValue;
}

/**
 * Sets promegaCookiePolicy with correct expiry and other
 * cookie properties
 */
function setPromegaCookie(cookieValue) {

    cookie.set(PROMEGA_COOKIE_POLICY, cookieValue, {
        expires: PROMEGA_COOKIE_POLICY_MAX_AGE,
        path: "/"
    });

    return cookieValue;
}

function hidePrivacyChoicesModal() {
    const COOKIE_MODAL_ELEMENT = document.querySelector(`.${PRIVACY_CHOICES_CLASS}`);
    if (COOKIE_MODAL_ELEMENT) {
        hideModal(COOKIE_MODAL_ELEMENT);
    }
}

function checkForMarketingCookies() {
    let marketingCookiesExist = getExistingCookieValue() >= COOKIE_TYPE_M ? true : false;
    if (marketingCookiesExist) {
        let hiddenCheckbox = document.getElementById("privacyMarketingCookiesCheckbox");
        hiddenCheckbox.checked = true;
        let changeEvent = new Event('change');
        hiddenCheckbox.dispatchEvent(changeEvent);
    }
}

/**
 * Shows the privacy choices modal dialog.
 */
function showPrivacyChoicesModal() {
    const PRIVACY_CHOICES_MODAL_ELEMENT = document.querySelector(`.${PRIVACY_CHOICES_CLASS}`);

    let newCookie = getExistingCookieValue();
    checkCookieCheckBoxes(newCookie);
    checkForMarketingCookies();

    if (PRIVACY_CHOICES_MODAL_ELEMENT) {
        showModal(PRIVACY_CHOICES_MODAL_ELEMENT);
    }
}

function privacyOptionsTriggerClicked(event) {
    if (event.target.classList.contains("trigger--privacy-choices-modal")) {
        showPrivacyChoicesModal();
        event.preventDefault();
    }
}

function privacyChoicesModalSubmitTrigger(event) {
    let newCookieValue = calculateNewCookieValue();
    setPromegaCookie(newCookieValue);
    Promega.Util.updateCookiePolicyConsent(newCookieValue);
    hidePrivacyChoicesModal();
    trackEvent("Privacy Options", "Save", newCookieValue);
    event.preventDefault();
}



// Init code
if (typeof document !== "undefined") {
    document.body.addEventListener("click", privacyOptionsTriggerClicked);
    //const targetedAvertisingCheckbox = document.getElementById(PRIVACY_COOKIE_M);
    //targetedAvertisingCheckbox.addEventListener("change", calculateNewCookieValue);
    const privacySaveButton = document.querySelector(`.${PRIVACY_CHOICES_SAVE_BTN}`);
    privacySaveButton.addEventListener("click", privacyChoicesModalSubmitTrigger);
}